// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1L8H7","boxTitle":"Qualiphy_boxTitle__34RAw","box":"Qualiphy_box__3_hVV","toggleWrap":"Qualiphy_toggleWrap__2olhf"};